<template>
  <v-card class="mx-0 mb-0">
    <v-data-table
      height="550"
      md="10"
      v-model="selected"
      fixed-header
      :search="id"
      :headers="headers"
      :items="table.items"
      class="text-truncate"
      :options.sync="options"
      :server-items-length="table.total"
      :loading="loading.table"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-page-first',
        lastIcon: 'mdi-page-last',
        prevIcon: 'mdi-chevron-left',
        nextIcon: 'mdi-chevron-right',
        itemsPerPageOptions: [5, 10, 20, 50],
        itemsPerPageText: 'Linhas por página:',
        pageText: `${
          (options.page - 1) * options.itemsPerPage + 1
        } a ${Math.min(table.total, options.page * options.itemsPerPage)} de ${
          table.total
        }`,
      }"
      no-data-text="Sem dados disponíveis"
      loading-text="Carregando..."
    >
      <!-- <span>{{new Date()}}</span> -->
      <template v-slot:item.comentario_da_causa="{ item }">
        <div class="text-truncate" style="max-width: 200px">
          {{ item.comentario_da_causa }}
        </div>
      </template>
      <template v-slot:item.comentario_geral="{ item }">
        <div class="text-truncate" style="max-width: 200px">
          {{ item.comentario_geral }}
        </div>
      </template>
      <template v-slot:item.data_da_entrevista="{ item }">
        <div class="text-truncate" style="max-width: 80px">
          {{ item.data_da_entrevista.slice(8, -14) }}/{{
            item.data_da_entrevista.slice(5, -17)
          }}/{{ item.data_da_entrevista.slice(0, -20) }}
        </div>
      </template>
      <template v-slot:item.data_da_visita="{ item }">
        <div class="text-truncate" style="max-width: 80px">
          {{ item.data_da_visita.slice(8, -14) }}/{{
            item.data_da_visita.slice(5, -17)
          }}/{{ item.data_da_visita.slice(0, -20) }}
        </div>
      </template>
      <template v-slot:item.escolha_da_loja="{ item }">
        <div class="text-truncate" style="max-width: 400px">
          {{ item.escolha_da_loja }}
        </div>
      </template>
      <template v-slot:item.comentario_do_pedido="{ item }">
        <div class="text-truncate" style="max-width: 200px">
          {{ item.comentario_do_pedido }}
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="min-width: 18px">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-1" icon>
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="primary"
                  @click="select(item)"
                  >mdi-pencil</v-icon
                >
              </v-btn>
            </template>
            <span class="ml-0">Editar</span>
          </v-tooltip>
          <!--
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mx-2" icon>
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  color="secondary"
                  @click="redirect(item)"
                  >mdi-account-arrow-right</v-icon
                >
              </v-btn>
            </template>
            <span>Redirecionar</span>
          </v-tooltip>
          -->
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "Tabela",

  data: () => ({
    options: {
      page: 1,
      itemsPerPage: 10,
    },
    headers: [
      { text: "", sortable: false, value: "actions" },
      {
        text: "STATUS",
        sortable: false,
        value: "status",
      },
      {
        text: "Data da Entrevista",
        align: "start",
        sortable: false,
        value: "data_da_entrevista",
      },

      {
        text: "ID",
        sortable: false,
        value: "id",
      },

      // {
      //   text: "Comentário da Causa",
      //   sortable: false,
      //   value: "comentario_da_causa",
      // },

      {
        text: "Comentário Geral",
        sortable: false,
        value: "comentario_geral",
      },

      {
        text: "Priorização",
        sortable: false,
        value: "PRIORIZACAO",
      },

      
      {
        text: "Marca",
        sortable: false,
        value: "marca",
      },

      {
        text: "Loja",
        sortable: false,
        value: "loja",
      },

      {
        text: "Canal de Atendimento",
        sortable: false,
        value: "canal_de_atendimento",
      },

      {
        text: "Entrega/Retirada",
        sortable: false,
        value: "entrega_retirada",
      },

      {
        text: "Categoria Prato",
        sortable: false,
        value: "CATEGORIA_PRATO",
      },

      {
        text: "Prato",
        sortable: false,
        value: "PRATO",
      },

      {
        text: "Data da Visita",
        sortable: false,
        value: "data_da_visita",
      },



      // {
      //   text: "Escolha da Loja",
      //   sortable: false,
      //   value: "escolha_da_loja",
      // },

      // {
      //   text: "Pedido Correto",
      //   sortable: false,
      //   value: "pedido_incorreto",
      // },

      // {
      //   text: "Motivo do Pedido Incorreto",
      //   sortable: false,
      //   value: "motivo_do_pedido_incorreto",
      // },

      // {
      //   text: "Comentário do Pedido",
      //   sortable: false,
      //   value: "comentario_do_pedido",
      // },
    ],
  }),

  computed: {
    ...mapState(["table", "loading"]),
  },

  watch: {
    options: {
      handler(newValue, oldValue) {
        if (
          newValue.page !== oldValue.page ||
          newValue.itemsPerPage !== oldValue.itemsPerPage
        ) {
          this.getData();
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations([
      "setDetails",
      "setActive",
      "setParams",
      // "setRedirect",
      // "setRedirectActive",
    ]),
    ...mapActions(["getTable"]),

    select(row) {
      // console.log("row", row);
      this.setDetails({ details: row });
      this.setActive({ active: true });
    },

    // redirect(row) {
    //   this.setRedirect({ redirect: row });
    //   this.setRedirectActive({ redirectActive: true });
    // },

    getData() {
      this.setParams({
        page: this.options.page,
        rows: this.options.itemsPerPage,
      });
      this.getTable();
    },
    formatDates(date) {
      let dateTurn = date.split("T")[0];
      let split = dateTurn.split("-");
      date = split;
      date = new Date(`${split[1]}/${split[2]}/${split[0]}`);
      return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    },
  },

  filters: {
    date: (str) => new Date(str).toLocaleString(),
  },
};
</script>
